var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 17,
    viewBox: "0 0 30 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 13.2535C19.0795 13.2535 18.3349 13.9939 18.3349 14.9103C18.3349 15.8268 19.0795 16.5672 20.0013 16.5672H28.3336C29.2553 16.5672 30 15.8268 30 14.9103V6.62609C30 5.70965 29.2553 4.96924 28.3336 4.96924C27.4118 4.96924 26.6671 5.70965 26.6671 6.62609V10.908L17.8453 2.14225C17.1944 1.49504 16.1372 1.49504 15.4863 2.14225L10.0026 7.59431L2.84729 0.485404C2.19633 -0.161801 1.13917 -0.161801 0.488218 0.485404C-0.162739 1.13261 -0.162739 2.18367 0.488218 2.83088L8.82047 11.1151C9.47142 11.7623 10.5286 11.7623 11.1795 11.1151L16.6684 5.65787L24.308 13.2535H20.0013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.25a6fc2f1473459b8556b100ac528ddd.svg";
export { ForwardRef as ReactComponent };